import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const tabs = [
  { label: "Semua", code: null },
  { label: "Peduli Sumatera", code: "sumatera" },
  { label: "Peduli Lansia", code: "lansia" },
  { label: "Peduli Palestina", code: "palestina" },
  { label: "Peduli Sudan", code: "sudan" },
  { label: "Bangkit Berdaya", code: "yatim" },
];

const VisitorStats = () => {
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const [data, setData] = useState<any[]>([]);
  const [meta, setMeta] = useState<any>(null);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const params: any = { page };

      if (activeTab.code) {
        params.website_code = activeTab.code;
      }

      const res = await axios.get(`${API_BASE}/api/visitor/stats`, { params });

      setData(res.data.data);
      setMeta(res.data.pagination);
    } catch (err) {
      console.error("Gagal ambil statistik visitor", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [activeTab, page]);

  return (
    <div className="mt-6">
      {/* ================= TAB ================= */}
      <div className="flex flex-wrap gap-2 mb-6">
        {tabs.map((tab) => (
          <button
            key={tab.label}
            onClick={() => {
              setActiveTab(tab);
              setPage(1);
            }}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition
              ${activeTab.label === tab.label ? "bg-orange-500 text-white" : "bg-orange-100 text-orange-700 hover:bg-orange-200"}`}>
            {tab.label}
          </button>
        ))}
      </div>

      {/* ================= CONTENT ================= */}
      {loading ? (
        <div className="text-center py-10">Loading...</div>
      ) : activeTab.code === null ? (
        /* ================= CARD MODE (SEMUA) ================= */
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {data.map((item) => (
            <div key={item.code} className="bg-white rounded-xl shadow border p-5 hover:shadow-lg transition">
              <h3 className="text-lg font-semibold text-orange-600">{item.name}</h3>
              <p className="mt-2 text-3xl font-bold text-gray-800">{item.total || "-"}</p>
              <p className="text-sm text-gray-500">Total Pengunjung</p>
            </div>
          ))}
        </div>
      ) : (
        /* ================= TABLE MODE (PER WEBSITE) ================= */
        <div className="bg-white rounded-xl shadow border overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead className="bg-orange-500 text-white">
              <tr>
                <th className="p-3 text-left">No</th>
                <th className="p-3 text-left">Tanggal</th>
                <th className="p-3 text-left">Jumlah Pengunjung</th>
              </tr>
            </thead>
            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td colSpan={3} className="p-4 text-center text-gray-500">
                    Tidak ada data
                  </td>
                </tr>
              ) : (
                data.map((item, index) => (
                  <tr key={item.date} className="border-t hover:bg-orange-50 transition">
                    <td className="p-3">{(meta.current_page - 1) * meta.per_page + index + 1}</td>
                    <td className="p-3">{new Date(item.date).toLocaleDateString("id-ID")}</td>
                    <td className="p-3 font-semibold text-orange-600">{item.total}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* ================= PAGINATION ================= */}
      {meta && meta.last_page > 1 && (
        <div className="flex justify-between items-center mt-4 text-sm">
          <span className="text-gray-600">
            Page {meta.current_page} dari {meta.last_page} | Total {meta.total}
          </span>

          <div className="flex gap-2">
            <button disabled={page === 1} onClick={() => setPage(page - 1)} className="px-3 py-1 rounded border disabled:opacity-50 hover:bg-orange-100">
              Prev
            </button>

            <button disabled={page === meta.last_page} onClick={() => setPage(page + 1)} className="px-3 py-1 rounded border disabled:opacity-50 hover:bg-orange-100">
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default VisitorStats;
